import { icons, type LucideIcon } from "lucide-react";

/**
 * MDX component that renders a heading with a Lucide icon.
 * Usage in MDX: <IconHeading icon="Smartphone">Mobile App</IconHeading>
 */
export function IconHeading({ icon, children }: { icon: string; children: React.ReactNode }) {
	const Icon: LucideIcon | undefined = icons[icon as keyof typeof icons];

	return (
		<span className="inline-flex items-center gap-2">
			{Icon && <Icon className="h-[1em] w-[1em] shrink-0 text-primary" />}
			{children}
		</span>
	);
}
